export default __webpack_public_path__ + "static/media/alpha.1440409c.png";